/* eslint-disable react/no-danger */
import React from 'react';
import Img from 'gatsby-image';
import shortid from 'shortid';
import { isNil, trim } from 'lodash-es';
import ResultBaseSectionList from './ResultBaseSectionList';
import Video from '../video';

const ResultBaseSection = ({ section, technology }) => {
  const injectImageBottom = section.photo && section.photoPosition === 'Bottom';
  const injectImageBottomInBg =
    section.photo && section.photoPosition === 'Bottom-image inside background';
  const { injectImageTop } = section;
  const textFullWidth =
    isNil(section.photo) ||
    section.photoPosition === 'Bottom' ||
    section.photoPosition === 'Background' ||
    section.photoPosition === 'Bottom-image inside background';
  const photoRight =
    section.photoPosition !== 'Bottom' &&
    section.photoPosition !== `Bottom-image inside background`;
  const photoBackground = section.photoPosition === 'Background';
  const sectionTechnology =
    trim(technology.technologies.sectionLocation).toLowerCase() ===
    section.title.toLowerCase();

  function checkImg() {
    const imgs = ['bulb.png'];
    if (section.photo) {
      const shorterSections = section.photo.childImageSharp.fluid.src;
      return shorterSections.endsWith(imgs.map(el => el));
    }
    return false;
  }

  return (
    <>
      {section.bannerVisible && section.banner ? (
        <Video className="storey video" videoSrcURL={section.banner} />
      ) : (
        <>
          <div
            className={`
        storey 
        ${injectImageBottom ? 'inject-img-bottom' : ''} 
        ${injectImageTop ? 'inject-img-top' : ''}
        ${checkImg() ? 'short-section' : ''}
      `}
          >
            <div className="container">
              <div className="row position-relative">
                <div
                  className={`${textFullWidth ? '' : 'col-lg-6'} col-md-12 ${
                    photoBackground ? 'mb-5' : ''
                  }`}
                >
                  <div className="expanse-content text-format">
                    <h2>{section.title}</h2>
                    {!!section.subtitle && (
                      <div className="col-lg-6 col-md-12 subtitle without bigger">
                        <div className="extra section-subtitle">
                          {section.subtitle}
                        </div>
                      </div>
                    )}
                    {!!section.body && (
                      <div
                        key="test"
                        className="section-body-container"
                        dangerouslySetInnerHTML={{
                          __html: section.body
                        }}
                      />
                    )}
                    {!!section.lists &&
                      section.lists.map(list => (
                        <ResultBaseSectionList
                          imgPosition={section.photoPosition}
                          list={list}
                          key={shortid.generate()}
                        />
                      ))}
                    {!!section.paragraph && (
                      <div className="row">
                        <div className="col-xl-8">
                          <div
                            key="test"
                            className="section-paragraph-container"
                            dangerouslySetInnerHTML={{
                              __html: section.paragraph
                            }}
                          />
                        </div>
                      </div>
                    )}
                    {!!section.photo && injectImageBottomInBg && (
                      <Img
                        fluid={section.photo.childImageSharp.fluid}
                        className="img-fluid bottom-section-image"
                        alt={section.title}
                        title={section.title}
                        imgStyle={{ objectFit: 'contain' }}
                      />
                    )}
                  </div>
                </div>

                {!!section.photo && photoRight && !photoBackground && (
                  <div className="col-lg-6 col-md-12">
                    <div className="expanse-image">
                      <Img
                        fluid={section.photo.childImageSharp.fluid}
                        className="img-fluid img-simple"
                        alt={section.title}
                        title={section.title}
                      />
                    </div>
                  </div>
                )}
                {!!section.photo && photoBackground && (
                  <div className="position-absolute w-100">
                    <Img
                      fluid={section.photo.childImageSharp.fluid}
                      className="bg-img ml-auto"
                      alt={section.title}
                      title={section.title}
                    />
                  </div>
                )}
              </div>
            </div>
            {!!section.photo && injectImageBottom && (
              <div className="container">
                <div className="storey-inject-img">
                  <div className="inject-img-wrapper">
                    <Img
                      fluid={section.photo.childImageSharp.fluid}
                      className="img-fluid bottom-section-image"
                      alt={section.title}
                      title={section.title}
                      imgStyle={{ objectFit: 'contain' }}
                    />
                  </div>
                </div>
              </div>
            )}
            {!!section.banner && <div className="container-fluid">file</div>}
          </div>
          {sectionTechnology && (
            <div className="storey">
              <div className="container">
                <div className="row">
                  <div className="col">
                    <div className="expanse-content text-format">
                      <h2>Used technology</h2>
                      <div className="technologies-beam">
                        <h3>The tech stack:</h3>
                        <div className="icons-wrapper inside-section">
                          {!!technology.technologies.icons &&
                            technology.technologies.icons.map(item => (
                              <div
                                className={`item tech-icon  ${item}`}
                                key={item}
                              />
                            ))}
                        </div>
                      </div>
                      <p>{technology.technologies.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ResultBaseSection;
